import type { ToastProps } from '@models/types';
import MuiSnackbar from '@mui/material/Snackbar';
import styled from 'styled-components';

export const Snackbar = styled(MuiSnackbar)`
    ${(props) => props.theme.breakpointTo.md} {
        left: 16px;
        right: 16px;
    }
`;

export const ToastItem = styled.div<Pick<ToastProps, 'variant'>>`
    display: flex;
    padding: 20px;
    background: ${(props) => props.theme.palette.textMain};
    border-radius: 26px;
    min-width: 275px;

    box-shadow: 0px 9px 21px 0px #0000001f;

    box-shadow: 0px 1px 0px 0px #0000000f;

    box-shadow: 0px 0px 1px 0px #d9defa inset;

    ${(props) => props.theme.breakpointTo.md} {
        padding: 16px 20px 16px 19px;
        max-width: none;
        width: 100%;
    }

    .status-icon-container {
        margin-right: 15px;
    }

    .warning-icon {
        color: ${(props) => props.theme.palette.secondaryA6};
    }

    .success-icon {
        color: ${(props) => props.theme.palette.secondaryA3};
    }

    .content-container {
        display: flex;
        flex-direction: column;
        padding-right: 15px;
        width: calc(100% - 42px);
    }

    .message {
        margin-top: 4px;
        white-space: pre-line;
    }

    .content {
        margin-top: 4px;
    }

    .header {
        position: relative;
    }

    .close-icon-container {
        position: absolute;
        right: -25px;
        top: -4px;
        color: ${(props) => props.theme.palette.primaryA7};

        svg {
            width: 19.2px;
            height: 19.2px;
        }
    }
`;
